// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--9-1!../../../node_modules/sass-loader/lib/loader.js??ref--9-2!./ydui.base.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("634d6e12", content, true);


//////////////////
// WEBPACK FOOTER
// ./src/common/scss/ydui.base.scss
// module id = 99
// module chunks = 0